import { status } from '../../config.ts'
import { wait } from '@/__mocks__/util/async.ts'
import { rolesPage1 } from '@/__mocks__/modules/roles/data.ts'

export default [
  {
    method: 'GET',
    path: '/roles/catalog',
    reply: async () => {
      await wait()
      return [status.ok, rolesPage1]
    }
  }
]
